import { ReferralFormSchema } from '../referralFormSchema';
import transformTypeOfHelp from './transformTypeOfHelp';

/** Transforms form section data to the format expected by the referral create API
 */
export const ReferralFormToCreateApiTransformSchema =
  ReferralFormSchema.transform((data) => {
    const typeOfHelp = transformTypeOfHelp(data.typeOfHelp);
    const { typeOfHelp: _, ...rest } = data;

    return {
      ...rest,
      inviteContexts: typeOfHelp.inviteContexts,
      consent: typeOfHelp.consent,
    };
  });
